import React from 'react';
import { useTheme } from 'styled-components';

import { Typography } from '../';
import { TabsStyled } from './styles';

type Props = {
  activeKey: string;
  activeTabColor?: string;
  items: Array<TabsPaneType>;
  onChange: (key: string) => void;
  activeStateType?: 'underline' | 'label';
  transparentBackground?: boolean;
  style?: React.CSSProperties;
};

export type TabsPaneType = {
  key: string;
  label: string;
};

const Tabs = ({
  activeKey,
  items,
  activeTabColor,
  onChange,
  activeStateType = 'underline',
  transparentBackground = false,
  style,
}: Props) => {
  const theme = useTheme();

  return (
    <TabsStyled
      $activeTabColor={activeTabColor}
      $transparentBackground={transparentBackground}
      style={style}
    >
      <div className={'tabs-label-container '}>
        {items.map((item) => (
          <div
            key={item.key}
            className={`tab ${
              item?.key === activeKey
                ? activeStateType === 'underline'
                  ? 'underline-active'
                  : 'label-active'
                : ''
            } `}
            onClick={() => onChange(item?.key)}
          >
            <Typography
              style={{
                color:
                  item?.key === activeKey
                    ? activeStateType === 'label'
                      ? theme.colors.secondary
                      : theme.colors.black
                    : theme.colors.tabText,
                fontWeight: '500',
                textAlign: 'center',
              }}
            >
              {item?.label}
            </Typography>
          </div>
        ))}
      </div>
    </TabsStyled>
  );
};

export default Tabs;
